// lib

// elvispos
import { KeyboardInput } from './keyboard-input';
import * as KeyboardLayouts from './keyboard-layouts';
import { Logger } from 'ngx-elvis-ds';
import { ViewChild } from '@angular/core';
import { DomController } from '@ionic/angular';
import { ConfigService } from '../../config.service';

export class Keyboard {

  active: Boolean = false;
  keyboardElement: any;
  inputsCount: number;
  activeLayout: string = null;
  keyboardLayouts: any = KeyboardLayouts.default;

  inputs: any[];
  keyboardHost: any;
  form: any;

  listeners: any = {
    key: {}
  };

  constructor(
    public domCtrl: DomController,
    public formName: string,
    public hostSelector: string | undefined = '#memphis-keyboard-host',
    public focus: boolean = true,
    public dismissable: boolean = true,
    public cssClass: string,
    private configSVC: ConfigService
  ) {
    this.form = document.forms[formName];
    this.inputs = document.forms[formName].getElementsByTagName('input');
    this.inputs = [...this.inputs, ...document.forms[formName].getElementsByTagName('textarea')];
    this.keyboardHost = document.querySelector(hostSelector);
    this.inputsCount = this.inputs.length;

    if (this.keyboardHost) {
      this.initKeyboardElement();
      this.initKeyboardInputs();
    }

    if (focus && this.inputs[0]) { 
      document.forms[formName].getElementsByTagName(this.inputs[0].tagName.toLowerCase())[0].focus();
    }
  }

  show(layout) {
    this.domCtrl.write(() => {
      if (layout === this.activeLayout && this.active) { return; }
      this.activeLayout = layout;
      this.active = true;

      this.keyboardElement.innerHTML = '';
      this.keyboardElement.classList.add('keyboard-layout_' + layout);
      this.keyboardElement.classList.remove('keyboard-container-hidden');
      this.keyboardHost.classList.remove('out');
      this.keyboardHost.classList.add('in');

      if (this.keyboardHost && this.keyboardHost.id !== 'payment-keypad-host') {
        if (this.activeLayout === 'number' || this.activeLayout === 'currency') {
          this.keyboardElement.classList.add('keyboard--aside');
        } else {
          this.keyboardElement.classList.remove('keyboard--aside');
        }
      }

      if (this.cssClass) {
        this.keyboardElement.classList.add(this.cssClass);
      }

      setTimeout(function () {
        //document.body.classList.add('memphis-keyboard-open');
      }, 100);

      this.drawLayout(layout);
    });
  }

  hide(layout) {
    this.domCtrl.write(() => {
      this.active = false;
  
      if (this.keyboardHost && this.keyboardHost.id !== 'payment-keypad-host') {
        if (this.activeLayout === 'number' || this.activeLayout === 'currency') {
          this.keyboardElement.classList.add('keyboard--aside');
        } else {
          this.keyboardElement.classList.remove('keyboard--aside');
        }
      }
  
      this.keyboardHost.classList.add('out');
      this.keyboardHost.classList.remove('in');
  
      setTimeout(() => {
        if (this.active) { return; }
        this.keyboardHost.classList.remove('out');
        this.keyboardElement.classList.add('keyboard-container-hidden');
        this.keyboardHost.innerHTML = '';
        //document.body.classList.remove('memphis-keyboard-open');
      }, 400);
    });
  }

  on(evt, key, action) {
    if (!this.listeners[evt]) { this.listeners[evt] = {}; }
    this.listeners[evt][key] = action;
  }

  off(evt, key, action) {
    if (!this.listeners[evt]) { return; }
    delete this.listeners[evt][key];
  }

  // private

  private drawLayout(layout) {
    const gridElmt = document.createElement('div');
    gridElmt.classList.add('keyboard-grid');

    this.keyboardLayouts[layout].forEach((row, rowIndex) => {
      const rowElmt = document.createElement('div');
      rowElmt.classList.add('keyboard-row');
      // rowElmt.classList.add(`keyboard-row--${rowIndex}`);

      const buildRow = (key, keyIndex) => {
        const keyElmt = document.createElement('button');
        const keySpanElmt = document.createElement('span');
        keyElmt.classList.add('keyboard-key');
        // keyElmt.classList.add(`keyboard-key--${keyIndex}`);

        // Parse the activeLayout configuration
        for (const dataName of Object.keys(key)) {
          switch (dataName) {
            case 'symbol':
              if (!key.label) {
                keySpanElmt.innerHTML = key[dataName];
                keyElmt.appendChild(keySpanElmt);
              }
              keyElmt.dataset.symbol = key[dataName];
              break;
            case 'label':
              keySpanElmt.innerHTML = key[dataName];
              keyElmt.appendChild(keySpanElmt);
              break;
            case 'blank':
              keySpanElmt.innerHTML = '&nbsp;';
              keyElmt.appendChild(keySpanElmt);
              keyElmt.dataset[dataName] = key[dataName];
              break;
            default:
              keyElmt.dataset[dataName] = key[dataName];
          }
        }
        rowElmt.appendChild(keyElmt);
      };

      row.forEach(buildRow);
      gridElmt.appendChild(rowElmt);
      this.keyboardElement.appendChild(gridElmt);
    });
    
    this.keyboardHost.appendChild(this.keyboardElement);
  }

  private initKeyboardInputs() {
    for (const i of this.inputs) {
      i.Keyboard = new KeyboardInput(this, i, this.configSVC);
    }
  }

  private initKeyboardElement() {
    this.domCtrl.write(() => {
      this.keyboardElement = document.createElement('div');
      this.keyboardElement.classList.add('keyboard-container');
      this.keyboardElement.addEventListener('mousedown', this.handleKeyboardEvents.bind(this));
      this.keyboardElement.addEventListener('touchstart', this.handleKeyboardEvents.bind(this));
    });
  }

  private handleKeyboardEvents(e) {
    e.preventDefault();
    // Check to make sure it's a key that's pressed
    if (!e.target.classList.contains('keyboard-key')) { return; }
    const keyInfo = e.target.dataset;
    for (const key of Object.keys(this.listeners['key'])) {
      const action = this.listeners['key'][key];
      action(keyInfo);
    }
  }
}
